import { useDashboard } from "@quillsql/react"
import { useState } from "react"

import { Skeleton } from "@particles"

import DashboardFilterBar from "@pages/Reports/ReportDashboard/DashboardFilterBar/DashboardFilterBar"
import ReportDetailDialog from "@pages/Reports/ReportDashboard/ReportDetailDialog/ReportDetailDialog"
import ReportEditorDialog from "@pages/Reports/ReportDashboard/ReportEditorDialog/ReportEditorDialog"
import ReportSection from "@pages/Reports/ReportDashboard/ReportSection/ReportSection"

import styles from "./DashboardContent.module.scss"
import { DashboardContentProps } from "./DashboardContent.types"

const SKELETON_COUNT = 6

export default function DashboardContent(props: DashboardContentProps) {
    const { dashboardId, useCache, isAddReportDialogOpen, onAddReportDialogChange } = props

    const { isLoading, sections, sectionOrder, filters, applyFilters } = useDashboard(dashboardId, {
        frontendCacheConfig: useCache ? { cacheType: "memory" } : undefined,
    })
    const [selectedReportId, setSelectedReportId] = useState<string | null>(null)

    if (isLoading) {
        return (
            <div className={styles.base}>
                <div className={styles.skeletonGrid}>
                    {Array.from({ length: SKELETON_COUNT }).map((_, index) => (
                        <div key={index} className={styles.skeletonCard} aria-disabled="true">
                            <Skeleton height={200} />
                        </div>
                    ))}
                </div>
            </div>
        )
    }

    return (
        <div className={styles.base}>
            {filters.length > 0 && <DashboardFilterBar filters={filters} onApplyFilters={applyFilters} />}

            {sectionOrder.map((sectionEntry) => {
                const sectionReports = sections?.[sectionEntry.section] ?? []

                return (
                    <ReportSection
                        key={sectionEntry.section}
                        sectionName={sectionEntry.section}
                        reportOrder={sectionEntry.reportOrder}
                        reports={sectionReports}
                        onReportClick={setSelectedReportId}
                    />
                )
            })}

            {selectedReportId && (
                <ReportDetailDialog
                    isOpen={!!selectedReportId}
                    onOpenChange={(open) => {
                        if (!open) {
                            setSelectedReportId(null)
                        }
                    }}
                    reportId={selectedReportId}
                    dashboardId={dashboardId}
                />
            )}
            <ReportEditorDialog
                isOpen={isAddReportDialogOpen}
                onOpenChange={onAddReportDialogChange}
                dashboardId={dashboardId}
            />
        </div>
    )
}
